import React from 'react';
import { Box } from '@mui/material';

import { useColorFromEnum } from '../../hooks';

export interface ColorDotProps {
  /** Color enum from appointment type (e.g., 'color1', 'color2') */
  colorEnum?: string | null;
  /** Size of the dot in pixels (default: 16) */
  size?: number;
  /**
   * Forwarded to the root element. Required for MUI to style the dot as a
   * Chip `icon` — MUI clones the icon and injects the `MuiChip-icon` class
   * that supplies the icon's spacing/alignment.
   */
  className?: string;
}

/**
 * Reusable color dot component for displaying appointment type colors
 * Uses the color hook to map enum values to actual theme colors
 *
 * @example
 * <ColorDot colorEnum="color1" size={16} />
 * <ColorDot colorEnum={appointmentType.color} />
 */
export const ColorDot: React.FC<ColorDotProps> = ({ colorEnum, size = 16, className }) => {
  const hexColor = useColorFromEnum(colorEnum);

  return (
    <Box
      className={className}
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: hexColor,
        border: '2px solid rgba(0, 0, 0, 0.1)',
        flexShrink: 0,
      }}
    />
  );
};
